<template>
  <div>
    <div class="p-5 bg-white rounded non-print">
      <span style="float: right; margin-top: -5px">
        <v-btn class="close" icon @click="isSettingDialog = true">
          <v-icon >mdi-cog-outline</v-icon>
        </v-btn>
      </span>
      <div class="py-6 text-xl text-center">{{ $t('contract.report_summary_of_trader_near_contract_expired') }}</div>
      <div class="flex justify-end py-3 align-center">
        <small class="gray--text" v-if="seleteContracts.length <= 0">{{ $t('validate.please_select_contract_to_renew') }}</small>
        <v-btn class="blue white--text mx-1" :disabled="seleteContracts.length <= 0" style="margin-left:10px;"
          @click="clickRenewContracts()">
          <v-icon>mdi-plus</v-icon>
          {{ $t('validate.renew_contract_count', { count: seleteContracts.length }) }}
        </v-btn>
        <v-btn class="blue white--text mx-1" @click="exportExcel" :disabled="isLoading" :loading="isLoading">
          <v-icon left>mdi-file-excel</v-icon>Export Excel
        </v-btn>
        <v-btn class="blue white--text mx-1" @click="printPDF" :disabled="isLoading" :loading="isLoading">
          <v-icon left>mdi-file-excel</v-icon>{{ $t('print_pdf') }}
        </v-btn>
        <FilterColumnDataTable v-model="headers" @onSuccess="onSelectFilterColumn" dataTableName="ReportCheckin" :disableIcon="true"/>
      </div>
      <div>
        <v-data-table
          v-if="dataTable"
          :headers="dataTable.headers"
          :items="dataTable.data"
          :items-per-page="itemsPerPage"
          class="elevation-1 v-data-table-report data-table-contract-exp"
          item-key="objectId"
          v-model="seleteContracts"
          :show-select="!isPrinting"
          :single-select="false"
          id="printarea"
          :loading="isLoading"
          @toggle-select-all="selectAllToggle"
          :no-data-text="$t('noinfo')"
          :no-results-text="$t('no_matching_records_found')"
        >
          <template v-slot:header.businessName="{header}"> 
            <div class="text-nowrap-table business-name" style="min-width:180px;">{{header.text}}</div>
          </template>
          <template v-slot:header.customerFullName="{header}">
            <div class="text-nowrap-table customer-name" style="min-width:180px;">{{header.text}}</div>
          </template>
          <template v-slot:header.areasText="{header}">
            <div class="text-nowrap-table area-name" style="min-width:100px;">{{header.text}}</div>
          </template>

          <template v-slot:body="{ items, isSelected, select }">
            <tbody>
              <template v-for="item in items">
                <tr>
                  <td class="non-print">
                    <v-simple-checkbox v-if="item.checkRenew" :value="isSelected(item)" @input="select(item, !isSelected(item))"></v-simple-checkbox>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <v-simple-checkbox v-bind="attrs" v-on="on" readonly disabled></v-simple-checkbox>
                      </template>
                      <span v-if="item.isSuspend">{{ $t('suspend.cannot_renew_contract_because_of_suspend') }}</span>
                      <span v-else-if="item.renewAppeal">{{ $t('validate.waiting_for_approval') }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <div class="text-no-wrap">
                      {{ item.contractId }}
                    </div>
                  </td>
                  <td class="hd-resize text-truncate">
                    {{ item.businessName }}
                  </td>
                  <td class="hd-resize text-truncate">
                    {{ item.customerFullName }}
                  </td>
                  <td class="hd-resize text-truncate area-name text-center">
                    {{ item.areasText }}
                  </td>
                  <td>{{ item.stallType ? $t(`contact.stall_type.${item.stallType}`) : '-' }}</td>
                  <td class="text-center">
                    <v-chip :class="item.status.color" @click="openContractDialog(item)">{{ item.status.text }}</v-chip>
                  </td>
                  <td>{{ dateFormat(item.startDate) }}</td>
                  <td>{{ dateFormat(item.endDate) }}</td>
                  <td class="text-center">
                    <v-chip v-if="item.ageExpireStatus" :color="item.ageExpireStatus.color">{{ item.ageExpireStatus.text }}</v-chip>
                  </td>
                  <td class="non-print">
                    <v-btn small icon @click="item.isExpand = !item.isExpand" v-if="hashContractLog && hashContractLog[item.objectId]">
                      <v-icon v-if="item.isExpand">mdi-chevron-up</v-icon>
                      <v-icon v-else>mdi-chevron-down</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <template v-if="item.isExpand && hashContractLog && hashContractLog[item.objectId]">
                  <tr v-for="log in hashContractLog[item.objectId]" :key="log.objectId">
                    <td class="non-print"></td>
                    <td>{{ log.oldContract.contractId }}</td>
                    <td>
                      <div> {{ log.oldContract.businessName }} </div>
                    </td>
                    <td>
                      <div> {{ log.oldContract.customerFullName }} </div>
                    </td>
                    <td class="hd-resize text-truncate">
                      <div class="text-center"> {{ log.oldContract.areasText }} </div>
                    </td>
                    <td>{{ log.oldContract.stallType == "temporary" ? $t('contact.stall_type.temporary') : $t('contact.stall_type.regularly') }}</td>
                    <td></td>
                    <td>{{ dateFormat(log.oldContract.startDate) }}</td>
                    <td>{{ dateFormat(log.oldContract.endDate) }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </div>
    <ContractDetailDialog 
      v-model="isContractDialog" 
      :contractId="tempContract ? tempContract.objectId : null" 
      :show-area="true" 
      :projectId="projectId"
      :marketId="marketId" 
      initTab="Bill"/>
    <RenewContractDialog
      v-model="isRenewContractDialog"
      :marketId="marketId"
      :projectId="projectId"
      :contracts="seleteContracts"
      @onSuccess="initData()"
    />
    <ContractExpiredSettingDialog
      v-model="isSettingDialog"
      :marketId="marketId"
      @onSuccess="initData()"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ContractDocument, ContractTemplate, Contract } from "../classes"
import DocumentEditorDialog from "@/components/DocumentEditorDialog.component.vue"
import FilterColumnDataTable from "@/components/FilterColumnDataTable.vue"
import ContractDetailDialog from "@/components/ContractDetailDialog";
import RenewContractDialog from "@/components/RenewContractDialog";
import ContractExpiredSettingDialog from "@/components/ContractExpiredSettingDialog";
import { Excel } from "../exports";
export default {
  components: {
    DocumentEditorDialog,
    FilterColumnDataTable,
    ContractDetailDialog,
    RenewContractDialog,
    ContractExpiredSettingDialog
  },
  computed: {
    ...mapGetters({
      invoicesRecognizance: "invoice/getInvoicesRecognizance",
      billingSettings: "billingSetting/getBillingSettings",
    }),
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    userFullName() {
      return this.$store.getters["user/getFullName"];
    },
    dataTable() {
      return {
        headers: this.headers && this.headers.length ? this.headers.filter(h => h.isShow) : [],
        data: this.contracts && this.contracts.length ? this.contracts : []
      }
    }
  },
  watch: {
    isContractDialog(val) {
      if(val === false) this.initData()
    },
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      isLoading: false,
      isLoadDataExport: false,
      contracts: null,
      isShowSelectContract: false,
      seleteContracts: [],
      project: null,
      market: null,
      tempContract: null,
      isContractDialog: false,
      menuDate: false,
      formData: {
        date: this.$moment().format("YYYY-MM-DD"),
      },
      itemsPerPage: 10,
      isPrinting: false,
      hashContractLog: null,
      isRenewContractDialog: false,
      isSettingDialog: false,
      headers: []
    };
  },
  created() {
    if (this.admin) {
      this.project = this.admin.project;
      this.market = this.admin.market;
    }
    if (this.employee) {
      this.project = this.employee.project;
      this.market = this.employee.market;
    }

    this.headers = [
        {
          value: "contractId",
          text: this.$t('contract.contract_number_only'),
          width: "120px",
          align: "center"
        },
        {
          value: "businessName",
          text: this.$t('contract.business_name'),
          width: "200px",
          sortable : false,
        },
        {
          value: "customerFullName",
          text: this.$t('contract.contract_owner_name'),
          width: "200px",
          sortable : false,
        },
        {
          value: "areasText",
          text: this.$t('area.space'),
          width: "100px",
          sortable : true,
          class: "custom-sort"
        },
        {
          value: "stallType",
          text: this.$t('area.stall_type'),
          align: "center"
        },
        {
          value: "status",
          text: this.$t('payment.title'),
          align: "center"
        },
        {
          value: "startDate",
          text: this.$t('start_date'),
          align: "center"
        },
        {
          value: "endDate",
          text: this.$t('end_date'),
          align: "center"
        },
        {
          value: "ageExpireStatus",
          text: this.$t('status'),
          sortable: false,
          align: "center",
          width: "100px"
        },
        {
          text: '',
          value: 'data-table-expand',
          class: "non-print"
        },
    ];
  },
  mounted() {
    this.intiDataTable()
    this.initData()
  },
  methods: {
    ...mapActions({
      getContractWillExpiredByMarket: "contract/getContractWillExpiredByMarket",
      getContractLogByContracts: "contractLog/getContractLogByContracts",
    }),
    intiDataTable() {
      if (this.headers && this.headers.length) {
        for (let header of this.headers) {
          if (header.isShow === undefined) header.isShow = true
          else header.isShow = false
        }
      }
      this.onSelectFilterColumn(this.headers.filter(h => h.isShow).map(h => h.value))
    },
    onSelectFilterColumn(hs) {
      let resHeaders = []
      let hst = []
      let filterDataTable = localStorage.getItem("filterDataTable");
      filterDataTable = filterDataTable ? JSON.parse(filterDataTable) : null
      let lhs = filterDataTable && filterDataTable['ReportRenewContract'] ? filterDataTable['ReportRenewContract'] : null
      if (lhs && lhs.length) hst = lhs
      else if (hs) hst = hs
      for (let header of this.headers) {
        header.isShow = hst.find(h => h == header.value) ? true : false;
        resHeaders.push(header)
      }
      this.headers = resHeaders
    },
    async initData(date) {
      this.isLoading = true
      try {
        this.contracts = []
        this.seleteContracts = []
        let contracts = await this.getContractWillExpiredByMarket({
          marketId: this.marketId,
          date: this.$moment(this.formData.date).endOf("day").toDate()
        })
        for(let contract of contracts){
          if(contract.isActive && !contract.isRenewEffective && !contract.isNotCheckInArea){
            contract.formDate = this.$moment(this.formData.date).endOf("day").toDate()
            contract.isExpand = false
            this.contracts.push(contract)
          }
        }
        let contractIds = this.contracts.map(d => d.objectId)
        let contractLogs = await this.getContractLogByContracts({
          contractIds: contractIds,
          type: "renew",
          include: ["oldContract.customer", "oldContract.areas", "newContract"]
        })
        this.hashContractLog = {}
        for(let contractLog of contractLogs){
          contractLog.oldContract = new Contract(contractLog.oldContract)
          contractLog.newContract = new Contract(contractLog.newContract)

          if (!this.hashContractLog[contractLog.contract.objectId])
            this.hashContractLog[contractLog.contract.objectId] = []
          this.hashContractLog[contractLog.contract.objectId].push(contractLog)
        }
        this.isLoading = false
      } catch (err) {
        console.log(err)
        this.isLoading = false
        this.$toast.show({
          content: `${this.$t('error')}`,
          color: "error"
        });
      }
    },
    openContractDialog(contract) {
      this.tempContract = contract
      this.isContractDialog = true
    },
    selectAllToggle(props) {
      let availableItems = props.items.filter(d => d.checkStatus)
      if (this.seleteContracts.length !== availableItems.length) {
        this.seleteContracts = props.items.filter(d => d.checkStatus);
      } else {
        this.seleteContracts = [];
      }
    },
    clickRenewContracts() {
      this.isRenewContractDialog = true;
    },
    dateFormat(date, isCheckExpire = false) {
      let res = "-";
      if (date && date.iso) {
        if (isCheckExpire) {
          let age = this.ageExpire(date);
          res = `${this.$moment(date.iso).format("DD/MM/YYYY")} (${age < 0 ? this.$t('already_expired') : `${this.$t('in_another')} ${age} ${this.$t('day')}`})`;
        } else {
          res = this.$moment(date.iso).format("DD/MM/YYYY");
        }
      }
      return res;
    },
    exportExcel() {
      Excel.reportContractWillExpire(this.contracts)
    },
    printPDF() {
      const tempItemsPerPage = this.itemsPerPage
      this.itemsPerPage = -1
      this.isPrinting = true
      setTimeout(() => {
        let printarea = document.getElementById("printarea").innerHTML;
        let printPreviewTopic = document.getElementById("print-preview-topic");
        let printPreviewcontent = document.getElementById("print-preview-content");
        let printPreviewFooter = document.getElementById("print-preview-footer");

        printPreviewTopic.innerHTML = `
          <h2 style="text-align: center;" class="my-4">
            <b>${this.$t('contract.report_summary_of_trader_near_contract_expired')}</b>
          </h2>
          <p style="text-align: center;">${this.market.name}</p>
          <p style="text-align: center;">
            ${this.$moment().format("D MMMM YYYY")}
          </p>
        `
        printPreviewcontent.innerHTML = printarea
        printPreviewFooter.innerHTML = `<div style="text-align: right;"><b>${this.$t('print_by')}</b> ${this.userFullName} <b>${this.$t('when')}</b> ${this.$moment().format("lll")}</div>`
        window.print();
        this.itemsPerPage = tempItemsPerPage
        this.isPrinting = false
      }, 200)

    }
  },
};
</script>

<style lang="scss" scoped>
.doc {
  font-size: 13px;
}
.text-nowrap-table.area-name,
.text-nowrap-table.customer-name {
  width: 100%;
}

.data-table-contract-exp::v-deep td {
  max-width: 200px;
}

.data-table-contract-exp::v-deep td.hd-resize.area-name {
  max-width: 80px;
}


.data-table-contract-exp::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 24px;
    top: 18px;
  }
}
</style>